export default __webpack_public_path__ + "static/media/9-2.040fcb2b.mp3";